import { useActions } from '../utils/hooks'
import MinimalNav from './MinimalNav'
import { Button } from '@bm-js/atlascloud-ui'

const FreeTierExpiredOverlay = () => {
  const { signOut } = useActions()
  return (
    <>
      <MinimalNav />
      <div className='flex h-screen w-screen items-center justify-center'>
        <div className='flex flex-col items-center'>
          <p className='text-center text-xl font-bold'>
            Din gratisversion av Atlas Cloud har löpt ut.{' '}
            <a
              className='text-primary-400 underline'
              href='mailto:info@bucketmedia.se'
            >
              <br />
              Kontakta oss
            </a>{' '}
            för att teckna ett avtal.
          </p>
          <Button className='mt-4' onClick={signOut}>
            Tillbaka
          </Button>
        </div>
      </div>
    </>
  )
}

export default FreeTierExpiredOverlay
